import { Fragment, useState, useContext, MouseEvent } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Box, Popover, Link as NavLink, Typography } from '@mui/material'

import { useLogout, useMe } from 'src/hooks'
import { HelperWrapper } from 'src/components'
import { ROUTES } from 'src/constants'
import { ETranslationNs } from 'src/types'
import { ThemeSwitchContext } from 'src/providers/theme-provider'

import { LogoutIcon } from 'src/assets/icons'
import useStyles from './styles'

interface INavbarDesktopProps {
  isOpen: boolean
}

const LogoutButton = ({ isOpen }: INavbarDesktopProps) => {
  const [t] = useTranslation(ETranslationNs.Navbar)
  const { logout } = useLogout()
  const { refetch } = useMe()
  const { setWhiteLable } = useContext(ThemeSwitchContext)
  const navigate = useNavigate()
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  const classes = useStyles({ isOpen })

  const handleLogout = async () => {
    setWhiteLable(undefined)
    await refetch()

    await logout()
    navigate(ROUTES.LOGIN)
  }

  const handlePopoverOpen = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handlePopoverClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl) && !isOpen

  return (
    <Fragment>
      <NavLink
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        onClick={handleLogout}
        className={classes.link}
      >
        <Box width={25}>
          <LogoutIcon />
        </Box>
        <span style={{ display: isOpen ? 'block' : 'none' }} className={`${classes.titleWrapper}`}>
          <HelperWrapper ns={ETranslationNs.Navbar} t="log-out-button-text" />
        </span>
      </NavLink>
      <Popover
        sx={{ pointerEvents: 'none' }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'left',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
        disableScrollLock
      >
        <div className={classes.textWrapper}>
          <Typography className={classes.title}>{t('log-out-button-text.v')}</Typography>
        </div>
      </Popover>
    </Fragment>
  )
}

export { LogoutButton }
